import request from '../helpers/request';

export const changeRequestPriority = ({ requestId, priorityId }) => {
  return request.put(
    `/Request/priority/${requestId}`,
    { priorityId },
    'Не удалось поменять приоритет заявки',
    'Error'
  );
};
